import React from "react";
import {
  Container,
  Heading,
  Project,
  Subheading,
  Description,
  Stack,
  Skill,
  ProjectsContainer,
  Text,
} from "./OtherProjects.Styled";
import { FiFolder } from "react-icons/fi";
import { commonUpAppearVariants } from "../../animations/motion";
import { motion } from "framer-motion";

const Projects = [
  {
    name: "Thanglong Restaurant",
    description:
      "Delivered a restaurant website that centralizes daily menus, announcements, and essential venue information for customers.",
    stack: ["React", "Styled Components", "Firebase", "JavaScript", "Heroku"],
  },
  {
    name: "Conversational Portfolio",
    description:
      "Designed and built a conversational portfolio around a chat interface, including contextual replies and milestone-based interactions.",
    stack: ["React", "Styled Components", "Firebase", "JavaScript", "Heroku"],
  },
  {
    name: "Ayurveda Space",
    description:
      "Built a client communication platform for an Ayurveda practitioner, combining authentication with direct, real-time messaging.",
    stack: ["React", "Styled Components", "Firebase", "JavaScript", "Heroku"],
  },
];

const OtherProject = ({ project }) => {
  return (
    <Project
      as={motion.article}
      variants={commonUpAppearVariants}
      initial="closed"
      whileInView="open"
      whileHover={{ y: -6 }}
      exit={{
        opacity: 0,
        y: 18,
        scale: 0.97,
        transition: { duration: 0.18, ease: "easeOut" },
      }}
      transition={{ type: "spring", stiffness: 300, damping: 24 }}
      viewport={{ once: true, amount: 0.18 }}
    >
      <Description>
        <FiFolder aria-hidden="true" />
        <Subheading>{project.name}</Subheading>
        <Text>{project.description}</Text>
      </Description>
      <Stack>
        {project.stack.map((skill, j) => (
          <Skill key={j}>{skill}</Skill>
        ))}
      </Stack>
    </Project>
  );
};

const OtherProjects = () => {
  return (
    <Container>
      <Heading>Earlier Projects</Heading>
      <ProjectsContainer>
        {Projects.map((project) => (
          <OtherProject project={project} key={project.name} />
        ))}
      </ProjectsContainer>
    </Container>
  );
};

export default OtherProjects;
